import { render } from "./PolicyPage.vue?vue&type=template&id=5e1cd0c0&scoped=true"
import script from "./PolicyPage.vue?vue&type=script&lang=js"
export * from "./PolicyPage.vue?vue&type=script&lang=js"

import "./PolicyPage.vue?vue&type=style&index=0&id=5e1cd0c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1cd0c0"]])

export default __exports__